import React from 'react'

const BackgroundLines: React.FC = () => {
  return (
    <div className="mi-bglines">
      <span></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  )
}

export default BackgroundLines
